import { render, staticRenderFns } from "./DeliveryEvolutionMainNumberOpinion.vue?vue&type=template&id=0345fd1f&lang=pug"
import script from "./DeliveryEvolutionMainNumberOpinion.vue?vue&type=script&lang=js"
export * from "./DeliveryEvolutionMainNumberOpinion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports